<template>
  <div>
    <template>
      <h4
        class="not-margin"
        :style="{
          fontWeight: 'bold',
          color: '#dc3545',
          fontSize: '18px',
          marginTop: '10px',
        }"
      >
        <i
          class="fal fa-trash-alt"
          :style="{ width: '30px', fontSize: '18px' }"
        ></i>
        ລຶບສະຖານະການເຄື່ອນໄຫວລ່າສຸດ
      </h4>
    </template>

    <div class="info-box" :style="{ marginTop: '15px' }">
      <p><strong>ເລກບິນ:</strong> {{ shipment_number }}</p>
      <div v-if="latestTracking" class="latest-tracking-info">
        <p><strong>ສະຖານະລ່າສຸດ:</strong> {{ latestTracking.message }}</p>
        <p><strong>ວັນທີ:</strong> {{ latestTracking.date }}</p>
      </div>
      <p class="warning-text">
        <i class="fal fa-exclamation-triangle"></i>
        ການດຳເນີນການນີ້ຈະລຶບສະຖານະການເຄື່ອນໄຫວລ່າສຸດຂອງບິນ
      </p>
      <p class="info-text">
        <i class="fal fa-info-circle"></i>
        ອະນຸຍາດລຶບສະຖານະ: ແພັກເຄື່ອງ, ກຳລັງຈັດສົ່ງ, ຮອດສາຂາປາຍທາງ ເທົ່ານັ້ນ
      </p>
    </div>

    <div class="modal-footer">
      <button
        type="button"
        class="button is-danger"
        @click="handleSubmit"
        :disabled="isLoading"
      >
        <i v-if="isLoading" class="fa fa-spinner fa-spin"></i>
        <i v-else class="fal fa-trash-alt"></i>
        ຢືນຢັນການລຶບ
      </button>
      <button
        type="button"
        class="button btn-cancel"
        @click="$emit('close')"
      >
        ຍົກເລີກ
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeleteLatestTrackingStatus',

  props: {
    shipment_number: {
      type: String,
      required: true
    },
    latestTracking: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      isLoading: false
    };
  },

  methods: {
    handleSubmit() {
      this.isLoading = true;

      const payload = {
        shipment_number: this.shipment_number
      };

      this.$axios.post('shipment/delete-latest-tracking-status', payload)
        .then((response) => {
          const data = response.data?.data || response.data;

          this.$vs.notification({
            color: 'success',
            title: 'ສຳເລັດ',
            text: `ລຶບສະຖານະລ່າສຸດສຳເລັດ (ID: ${data.deleted_tracking_status_id})`
          });
          this.$emit('success');
          this.$emit('close');
        })
        .catch(error => {
          this.isLoading = false;

          let errorMessage = 'ເກີດຂໍ້ຜິດພາດ';
          if (error.response && error.response.data) {
            errorMessage = error.response.data.message || errorMessage;
          }

          this.$vs.notification({
            color: 'danger',
            title: 'ຂໍ້ຜິດພາດ',
            text: errorMessage
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>

<style scoped>
.info-box {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 15px;
  border-left: 4px solid #dc3545;
}

.latest-tracking-info {
  background: #e9ecef;
  padding: 10px;
  border-radius: 5px;
  margin: 10px 0;
}

.warning-text {
  color: #856404;
  background: #fff3cd;
  padding: 10px;
  border-radius: 5px;
  margin: 10px 0;
}

.warning-text i {
  margin-right: 8px;
}

.info-text {
  color: #0c5460;
  background: #d1ecf1;
  padding: 10px;
  border-radius: 5px;
  margin: 10px 0;
}

.info-text i {
  margin-right: 8px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;
}

.btn-cancel {
  background: #6c757d;
  color: white;
}

.btn-cancel:hover {
  background: #5a6268;
  color: white;
}
</style>
